(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/expandable-box/assets/javascripts/expandable-box.js') >= 0) return;  svs.modules.push('/components/components/expandable-box/assets/javascripts/expandable-box.js'); 
var svs = svs || {};

(function(svs) {
  'use strict';

  svs.components = svs.components || {};

  svs.components.Expandablebox = function() {
    var self = this;

    $(window.document).on(
      'click',
      '.js-expandable-box .js-expandable-box-header',
      function(evt) {
        evt.preventDefault();
        self.openAndClose(this);
      }
    );

    this.open = function(element) {
      var parent = $(element)
          .parents('.js-expandable-box')
          .first(),
        arrowHolder = $(parent)
          .find('.js-expandable-box-icon-arrow')
          .first(),
        royalSliderView = $('.royalSlider');

      if (
        !parent.hasClass('expandable-box-open') &&
        !parent.hasClass('expandable-box-closed')
      ) {
        parent.addClass('expandable-box-open');
        arrowHolder.toggleClass('icon-menu-down');
        arrowHolder.toggleClass('icon-menu-up');

        if (royalSliderView.length) {
          $('.rsOverflow').height($('.rsActiveSlide').height());
        }
        $(parent).trigger('expandableBoxOpen');
        $(window.document).trigger('expandable-box-resize', parent);
      }
    };

    this.openAndClose = function(element) {
      var parent = $(element)
          .parents('.js-expandable-box')
          .first(),
        content = parent.find('.expandable-box-content').first(),
        arrowHolder = $(parent)
          .find('.js-expandable-box-icon-arrow')
          .first(),
        royalSliderView = $('.royalSlider'),
        primerSlider;

      $(element)
        .parents('.js-expandable-box-group')
        .find('.js-expandable-box')
        .each(function() {
          if (!$(this).is(parent) && $(this).hasClass('expandable-box-open')) {
            $(this).removeClass('expandable-box-open');
            var arrow = $(this)
              .find('.js-expandable-box-icon-arrow')
              .first();
            arrow.addClass('icon-menu-down');
            arrow.removeClass('icon-menu-up');
          }
        });

      if (
        !parent.hasClass('expandable-box-open') &&
        !parent.hasClass('expandable-box-closed')
      ) {
        if (parent.hasClass('js-expandable-box-animate')) {
          content.css('display', 'none');
          parent
            .addClass('expandable-box-open')
            .removeClass('expandable-box-closed');
          content.slideDown('fast', function() {
            content.removeAttr('style');
          });
        } else {
          parent
            .addClass('expandable-box-open')
            .removeClass('expandable-box-closed');
        }
      } else {
        if (parent.hasClass('expandable-box-closed')) {
          if (parent.hasClass('js-expandable-box-animate')) {
            content.css('display', 'none');
            parent
              .addClass('expandable-box-open')
              .removeClass('expandable-box-closed');
            content.slideDown('fast', function() {
              content.removeAttr('style');
            });
          } else {
            parent
              .addClass('expandable-box-open')
              .removeClass('expandable-box-closed');
          }
        } else {
          if (parent.hasClass('js-expandable-box-animate')) {
            content.css('display', 'block');
            parent
              .addClass('expandable-box-closed')
              .removeClass('expandable-box-open');
            content.slideUp('fast', function() {
              content.removeAttr('style');
            });
          } else {
            parent
              .addClass('expandable-box-closed')
              .removeClass('expandable-box-open');
          }
        }
      }
      if (parent.hasClass('expandable-box-open')) {
        $(parent).trigger('expandableBoxOpen');
      } else {
        $(parent).trigger('expandableBoxClose');
      }

      arrowHolder.toggleClass('icon-menu-down');
      arrowHolder.toggleClass('icon-menu-up');
      if (royalSliderView.length) {
        primerSlider = $('.rsOverflow');
        _.each(primerSlider, function(royalItem) {
          if ($.contains(royalItem, element)) {
            primerSlider = royalItem;
          }
        });
        $(window.document).trigger('resizeTabView');
      }
      $(window.document).trigger('expandable-box-resize', parent);
    };
    this.showLoader = function(element, inverted) {
      var arrowHolder = $(element)
          .find('.js-expandable-box-icon-arrow')
          .first(),
        loader = $(element).find('.js-expandable-box-loader-holder');

      if (!loader.length) {
        loader = $('<div></div>').addClass(
          'expandable-box-loader-holder js-expandable-box-loader-holder'
        );
        loader.appendTo(arrowHolder.parent());
        loader.data({ loader: new svs.components.Loader(loader) });
      }
      arrowHolder.hide();

      if (inverted) {
        inverted = 'inverted';
      }
      loader.data().loader.show(100, inverted);
    };
    this.hideLoader = function(element) {
      var arrowHolder = $(element)
          .find('.js-expandable-box-icon-arrow')
          .first(),
        loader = $(element).find('.js-expandable-box-loader-holder');

      if (loader.length) {
        loader.data().loader.hide();
      }
      arrowHolder.show();
    };
    return {
      openAndClose: this.openAndClose,
      open: this.open,
      showLoader: this.showLoader,
      hideLoader: this.hideLoader
    };
  };

  svs.components.expandablebox = new svs.components.Expandablebox();
})(svs);

 })(window);